import React from "react";
import alten from "../images/alten.png"
import godrej from "../images/configurator.png"
import hmel from "../images/hmel.png"

const achievementsData = [
  {
    title: "Godrej Interio",
    year: 2019,
    company: "Simulanis Solution Pvt Ltd",
    imageUrl: godrej,
    description:
      "Led the successful implementation of the interior design configurator tool, improving client engagement by 30%.",
  },
  {
    title: "HMEL",
    year: 2020,
    company: "Simulanis Solution Pvt Ltd",
    imageUrl: hmel,
    description:
      "Developed a custom industrial simulation that enhanced training efficiency for plant operators.",
  },
  {
    title: "Godrej Configurator",
    year: 2021,
    company: "Simulanis Solution Pvt Ltd",
    imageUrl: godrej,
    description:
      "Led the redesign of the product customization tool, which helped boost sales by 15%.",
  },
  {
    title: "Pinnacle Achiever Award",
    year: 2023,
    company: "ALTEN India",
    imageUrl: alten,
    description:
      "Recognized for outstanding performance in software delivery.",
  },
];

const Achievement = () => (
  <section className="achievement-section">
    <h1 className="heading">Achievements</h1>
    <div className="achievement-grid">
      {achievementsData.map(
        ({ title, year, company, imageUrl, description }, idx) => (
          <article key={idx} className="achievement-card">
            <img src={imageUrl} alt={title} className="achievement-img" />
            <div className="achievement-content">
              <h2 className="achievement-title">{title}</h2>
              <p className="achievement-meta">
                {year} &mdash; <em>{company}</em>
              </p>
              <p className="achievement-description">{description}</p>
            </div>
          </article>
        )
      )}
    </div>
  </section>
);

export default Achievement;
